import api from "@/api";


export async function isAuthenticated() {
    try {
        const response = await api.get("/auth/session");
        return response.status === 200;
    } catch (error) {
        return false;
    }
}